<template>
  <form>
    <div class="image-container mb-3" v-if="previewPath">
      <img :src="previewPath" alt="Uploaded Image Preview" />
    </div>
    <div class="form-group">
      <div ref="dashboardContainer"></div>
    </div>
    <!-- <v-btn :disabled="disabled" @click.prevent="confirmUpload" class="btn btn-primary btn-block mb-2">Confirm upload</v-btn> -->
  </form>
</template>

<script>
import HeicToJpeg from "@/plugins/uppyHeicToJpeg";
import Uppy from "@uppy/core";
import XHRUpload from "@uppy/xhr-upload";
// import AwsS3Multipart from "@uppy/aws-s3-multipart";

import Dashboard from "@uppy/dashboard";
import ImageEditor from "@uppy/image-editor";
import { IMAGE_EDITOR_SQUARE } from "@/utils/uppyImageEditor";
// import Form from "@uppy/form";
import Russian from "@uppy/locales/lib/ru_RU";
import English from "@uppy/locales/lib/en_US";
import Compressor from "@uppy/compressor";

import "@uppy/core/css/style.css";
import "@uppy/dashboard/css/style.css";
import "@uppy/image-editor/css/style.css";
import { RASTER_IMAGE_TYPES } from "@/utils/uploadFileTypes";

export default {
  props: {
    maxFileSizeInBytes: {
      type: Number,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      payload: null,
      previewPath: null,
      disabled: true,
      isLoading: false,
    };
  },
  mounted() {
    this.instantiateUppy();
  },
  beforeDestroy() {
    this.uppy.destroy();
  },
  methods: {
    // currentUser — новым объектом, не правкой на месте; форме профиля (у неё своя копия
    // пользователя) url уходит событием.
    applyUploadedAvatar(avatarUrl) {
      this.$store.commit("setCurrentUser", { ...this.$store.getters.getCurrentUser, avatar_url: avatarUrl });
      this.$emit("uploaded", avatarUrl);
    },
    instantiateUppy() {
      let self = this;
      this.uppy = new Uppy({
        debug: false,
        locale: this.$i18n.locale === "ru" ? Russian : English,
        // Без автозагрузки: файл правят в редакторе и отправляют кнопкой «Загрузить»
        // (utils/uppyImageEditor.js).
        autoProceed: false,
        allowMultipleUploadBatches: false,
        restrictions: {
          maxFileSize: this.maxFileSizeInBytes,
          minNumberOfFiles: 1,
          maxNumberOfFiles: 1,
          allowedFileTypes: RASTER_IMAGE_TYPES,
          // allowedFileTypes: ['image/*', 'application/doc', 'application/docx', 'application/pdf']
        },
      })
        .use(HeicToJpeg, { quality: 0.92, openEditorAfter: true })
        .use(Dashboard, {
          theme: this.theme,
          inline: false,
          trigger: ".UppyModalOpenerBtn",
          width: this.width,
          height: this.height,
          target: this.$refs.dashboardContainer,
          browserBackButtonClose: true,
          closeAfterFinish: true,
          proudlyDisplayPoweredByUppy: false,
          autoOpen: "imageEditor",
        })
        .use(ImageEditor, IMAGE_EDITOR_SQUARE)
        .use(Compressor, {
          quality: 0.7,
          limit: 5,
          // Потолок, а не целевой размер: width/height растягивали маленький кадр до
          // 1920×1080 и отключали strict (раздутый результат уходил вместо исходника).
          maxWidth: 1920,
          maxHeight: 1080,
          convertSize: 5000000,
          convertTypes: ["image/png"],
          preserveExif: false,
          locale: {
            strings: {
              // Shown in the Status Bar
              compressingImages: this.$i18n.locale === "ru" ? 'Сжимаем изображение...' : 'Compressing image...',
              compressedX: this.$i18n.locale === "ru" ? 'Сжато %{size} байт' : 'Compressed %{size} bytes',
            },
          },
        })
        .use(XHRUpload, {
          endpoint: `${this.$store.getters.getApiUrl}/api/v1/user_avatars`, // FT-018
          method: "post",
          formData: true,
          fieldName: "image",
          bundle: false,
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        });

      this.uppy.on("complete", (event) => {
        if (event.successful[0] !== undefined) {
          // this.payload = event.successful[0].response.body.path;
          // const imageName = uuid.v1();
          // let fileExtention = file.name.split(".")[1];
          // console.log(event.successful[0].s3Multipart.key);
          this.disabled = false;
          this.applyUploadedAvatar(event.successful[0].response.body);
        }
      });

      const uploadedFileData = (file, response) => {
        return JSON.stringify(response.body);
      };
    },
    updatePreviewPath({ path }) {
      this.previewPath = path;

      return this;
    },
    resetUploader() {
      this.uppy.cancelAll();
      this.disabled = true;

      return this;
    },
    confirmUpload() {
      if (this.payload) {
        this.disabled = true;
        this.axios
          .post("/store", { file: this.payload })
          .then(({ data }) => {
            this.updatePreviewPath(data).resetUploader();
            this.$notify("Файлы загружены!", "Вы успешно загрузили файлы!", "success", 5000);
          })
          .catch((err) => {
            console.error(err);

            this.resetUploader();
          });
      } else {
        this.$notify("Ошибка при загрузке!", this.error, "error", 5000);
      }
    },
  },
};
</script>

<style scoped>
.image-container {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: auto;
  margin-left: auto;
}

.image-container>img {
  width: inherit;
  height: inherit;
}
</style>
